import { render, staticRenderFns } from "./TableWs.vue?vue&type=template&id=903ae37a&scoped=true"
import script from "./TableWs.vue?vue&type=script&lang=js"
export * from "./TableWs.vue?vue&type=script&lang=js"
import style0 from "./TableWs.vue?vue&type=style&index=0&id=903ae37a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../wscpet/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "903ae37a",
  null
  
)

export default component.exports